import { GYM_SETUP_FILTERS } from '@steado/admin-contract/gyms';
import { z } from 'zod';

/**
 * The Gyms list's filters, in the URL like every other list's: a shareable
 * link, a working back button, and `.catch(undefined)` so a stale bookmark
 * degrades to the unfiltered list.
 */
export const gymsSearchSchema = z.object({
  search: z.string().trim().min(1).max(120).optional().catch(undefined),
  setup: z.enum(GYM_SETUP_FILTERS).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

export type GymsSearch = z.infer<typeof gymsSearchSchema>;
